// extracted by mini-css-extract-plugin
export default {"layout":"aFQAI","layoutUnsetOverflow":"_5F3z","feedback":"eWpdD","slideUp":"NJ9Cs"};